import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { GlobalCommunication } from '../global-communication.service';

@Injectable()
export class CatchErrorsInterceptor implements HttpInterceptor {
  constructor(private globalCommunication: GlobalCommunication) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    return next.handle(req).pipe(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      catchError((error: any) => {
        if (error.status === 401) {
          this.globalCommunication.emitLogout();
        } else {
          let serverError = error.error;

          if (serverError) {
            if (serverError instanceof Blob) {
              const reader: FileReader = new FileReader();

              reader.onloadend = () => {
                let readerResult = JSON.parse(reader.result as string);
                this.showServerMessages(readerResult.apiMessages);
              };

              reader.readAsText(serverError);
            } else {
              this.showServerMessages(serverError.apiMessages);
            }
          }
        }
        return throwError(error);
      }),
    );
  }

  private showServerMessages(serverMessages: string[]) {
    let messages: string[] = [];
    if (serverMessages) {
      for (let message of serverMessages) {
        messages.push(message);
      }
    }

    if (messages.length > 0) {
      this.globalCommunication.showErrors(messages);
    } else {
      this.globalCommunication.showError('Unknown error');
    }
  }
}
